/*
 * SPDX-FileCopyrightText: 2022 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
// import { getRevision } from '../../../../api/revisions'
import { VersionContent } from '@api/revisions/types';
import { useDarkModeState } from '../../../../hooks/common/use-dark-mode-state';
import { AsyncLoadingBoundary } from '../../../common/async-loading-boundary/async-loading-boundary';
// import { invertUnifiedPatch } from './invert-unified-patch';
// import { Optional } from '@mrdrogdrog/optional';
// import { useLazyFetchVersionContentQuery } from '@services/versionHistoryService';
// import { applyPatch, parsePatch } from 'diff';
import React from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';
import { DetailType, VersionIndexType } from './revision-modal';
import { UserAvatar } from '@components/common/user-avatar/user-avatar';
// import { useAsync } from 'react-use';

export interface RevisionViewerProps {
  selectedVersionIndex?: VersionIndexType;
  compareMethod: any;
  isSplitView: boolean;
  versionContent: {
    versionContentData: VersionContent[];
    versionContentIsLoading: boolean;
    versionContentError: Error | undefined;
    versionContentIsFetching: boolean;
  };
}

/**
 * Renders the diff viewer for a given revision and its previous one.
 */
export const RevisionViewer: React.FC<RevisionViewerProps> = ({
  selectedVersionIndex,
  compareMethod,
  isSplitView,
  versionContent: {
    versionContentData,
    versionContentIsLoading,
    versionContentError,
    versionContentIsFetching
  }
}) => {
  const darkModeEnabled = useDarkModeState();
  if (selectedVersionIndex === undefined) {
    return <h2 className='text-warning m-0'>Please select a version</h2>;
  }

  const titleUi = (verDetails: DetailType) => (
    <div className='d-flex align-items-center'>
      <UserAvatar
        showName={false}
        displayName={verDetails.userData.name}
        photoUrl={verDetails.userData.image}
      />{' '}
      <span className='mx-2'>{verDetails.date}</span>
    </div>
  );
  return (
    <AsyncLoadingBoundary
      loading={versionContentIsLoading || versionContentIsFetching}
      componentName={'RevisionViewer'}
      error={versionContentError}>
      <ReactDiffViewer
        leftTitle={
          isSplitView ? titleUi(selectedVersionIndex.verDetails.new) : undefined
        }
        rightTitle={
          isSplitView ? titleUi(selectedVersionIndex.verDetails.old) : undefined
        }
        oldValue={versionContentData?.[0].content ?? ''}
        newValue={versionContentData?.[1].content ?? ''}
        splitView={isSplitView}
        compareMethod={DiffMethod[compareMethod]}
        useDarkTheme={darkModeEnabled}
      />
    </AsyncLoadingBoundary>
  );
};
